import { useStorage } from './use-local-storage'

export function useSessionStorage<T>(
  key: string,
  defaultValue: T,
): [T, (value: T | ((prev: T) => T)) => void, () => void] {
  if (typeof window === 'undefined') {
    throw new TypeError('No sessionStorage available during server rendering')
  }
  return useStorage(window.sessionStorage, key, defaultValue)
}
